/* eslint-disable react-hooks/exhaustive-deps */
import { DownloadOutlined } from '@ant-design/icons';
import { Button, Table } from 'antd';
import classNames from 'classnames';
import { useEffect, useState } from 'react';
import PolicyService from '../../../services/Policy.service';
import { POLICY_NAME } from '../POLICY';
import usePermission from '../../../hooks/usePermission';

const DownloadPdf = ({ record, data, privacyId, htmlEn, html }) => {
    const { isAuditor } = usePermission();

    const [loading, setLoading] = useState(false);
    const downloadFile = async (lang, fileType, fileName) => {
        try {
            setLoading(true);
            const payload = {
                privacyNoticeId: data[privacyId],
                lang,
                fileType,
                htmlCode: lang === 'EN' ? htmlEn : html,
            };
            const res = await PolicyService.downloadFile(payload);
            if (res.data.resultData) {
                setLoading(false);
                const newBlob = convertBase64toBlob(
                    res.data.resultData?.bis,
                    'pdf'
                );
                let link = document.createElement('a');
                link.download = `${fileName}.pdf`;
                link.href = URL.createObjectURL(newBlob);
                link.click();
                link.remove();
            }
        } catch (error) {
            setLoading(false);
            console.log(error);
        }
    };

    const convertBase64toBlob = (content, contentType) => {
        contentType = contentType || '';
        const sliceSize = 512;
        const byteCharacters = window.atob(content); //method which converts base64 to binary
        const byteArrays = [];
        for (
            let offset = 0;
            offset < byteCharacters.length;
            offset += sliceSize
        ) {
            let slice = byteCharacters.slice(offset, offset + sliceSize);
            let byteNumbers = new Array(slice.length);
            for (let i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            let byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        let blob = new Blob(byteArrays, {
            type: contentType,
        }); //statement which creates the blob
        return blob;
    };
    return (
        <Button
            disabled={isAuditor}
            loading={loading}
            onClick={() => downloadFile(record.lang, 'pdf', record.name)}
            className="bg-[#F3F6F9] border-none"
            icon={<DownloadOutlined className="text-purple" />}
        ></Button>
    );
};

const DownloadFiles = ({
    data,
    type,
    policyObject: { privacyName, privacyId }, // privacyType, privacyId
    templateBody: { html, htmlEn, htmlPublish, htmlPublishEn },
    currentSelectName,
}) => {
    const { isAuditor } = usePermission();

    const [dataSource, setDataSource] = useState([]);

    const fileTypes = {
        PDF: 'pdf',
        DOCX: 'docx',
    };

    const fileLang = {
        TH: 'TH',
        EN: 'EN',
    };

    useEffect(() => {
        if (data) {
            let genarate = [];
            const split = data.updateDate.split('/');
            const year = split[2].split(' ');
            const date = `_${split[0]}-${split[1]}-${year[0]}_`;
            if (data) {
                if (data.status === 'Draft') {
                    genarate.push(
                        {
                            name:
                                `${currentSelectName?.nameTh}` +
                                date +
                                fileLang.TH,
                            type: fileTypes.DOCX,
                            lang: fileLang.TH,
                            version: data.version,
                            published: false,
                        },
                        {
                            name:
                                `${currentSelectName?.nameEn}` +
                                date +
                                fileLang.EN,
                            type: fileTypes.DOCX,
                            lang: fileLang.EN,
                            version: data.version,
                            published: false,
                            hidden: type === POLICY_NAME.DPA,
                        },
                        {
                            name:
                                `${currentSelectName?.nameTh}` +
                                date +
                                fileLang.TH,
                            type: fileTypes.PDF,
                            lang: fileLang.TH,
                            version: data.version,
                            published: false,
                        },
                        {
                            name:
                                `${currentSelectName?.nameEn}` +
                                date +
                                fileLang.EN,
                            type: fileTypes.PDF,
                            lang: fileLang.EN,
                            version: data.version,
                            published: false,
                            hidden: type === POLICY_NAME.DPA,
                        }
                    );
                } else {
                    if (data.status === 'Published' && data.hasChanged) {
                        genarate.push(
                            {
                                name:
                                    `${currentSelectName?.nameTh}` +
                                    date +
                                    fileLang.TH,
                                type: fileTypes.DOCX,
                                lang: fileLang.TH,
                                version: data.version,
                                published: false,
                                hasChanged: true,
                            },
                            {
                                name:
                                    `${currentSelectName?.nameEn}` +
                                    date +
                                    fileLang.EN,
                                type: fileTypes.DOCX,
                                version: data.version,
                                lang: fileLang.EN,
                                published: false,
                                hasChanged: true,
                                hidden: type === POLICY_NAME.DPA,
                            },
                            {
                                name:
                                    `${currentSelectName?.nameTh}` +
                                    date +
                                    fileLang.TH,
                                type: fileTypes.PDF,
                                version: data.version,
                                lang: fileLang.TH,
                                published: false,
                                hasChanged: true,
                            },
                            {
                                name:
                                    `${currentSelectName?.nameEn}` +
                                    date +
                                    fileLang.EN,
                                type: fileTypes.PDF,
                                version: data.version,
                                lang: fileLang.EN,
                                published: false,
                                hasChanged: true,
                                hidden: type === POLICY_NAME.DPA,
                            },
                            {
                                name:
                                    `${currentSelectName?.namePublishTh}` +
                                    date +
                                    fileLang.TH,
                                type: fileTypes.DOCX,
                                lang: fileLang.TH,
                                version: data.latestPublishVersion,
                                published: true,
                                hasChanged: true,
                            },
                            {
                                name:
                                    `${currentSelectName?.namePublishEn}` +
                                    date +
                                    fileLang.EN,
                                type: fileTypes.DOCX,
                                version: data.latestPublishVersion,
                                lang: fileLang.EN,
                                published: true,
                                hasChanged: true,
                                hidden: type === POLICY_NAME.DPA,
                            },
                            {
                                name:
                                    `${currentSelectName?.namePublishTh}` +
                                    date +
                                    fileLang.TH,
                                type: fileTypes.PDF,
                                version: data.latestPublishVersion,
                                lang: fileLang.TH,
                                published: true,
                                hasChanged: true,
                            },
                            {
                                name:
                                    `${currentSelectName?.namePublishEn}` +
                                    date +
                                    fileLang.EN,
                                type: fileTypes.PDF,
                                version: data.latestPublishVersion,
                                lang: fileLang.EN,
                                published: true,
                                hasChanged: true,
                                hidden: type === POLICY_NAME.DPA,
                            }
                        );
                    } else {
                        genarate.push(
                            {
                                name:
                                    `${currentSelectName?.nameTh}` +
                                    date +
                                    fileLang.TH,
                                type: fileTypes.DOCX,
                                lang: fileLang.TH,
                                version: data.latestPublishVersion,
                                published: true,
                            },
                            {
                                name:
                                    `${currentSelectName?.nameEn}` +
                                    date +
                                    fileLang.EN,
                                type: fileTypes.DOCX,
                                version: data.latestPublishVersion,
                                lang: fileLang.EN,
                                published: true,
                                hidden: type === POLICY_NAME.DPA,
                            },
                            {
                                name:
                                    `${currentSelectName?.nameTh}` +
                                    date +
                                    fileLang.TH,
                                type: fileTypes.PDF,
                                version: data.latestPublishVersion,
                                lang: fileLang.TH,
                                published: true,
                            },
                            {
                                name:
                                    `${currentSelectName?.nameEn}` +
                                    date +
                                    fileLang.EN,
                                type: fileTypes.PDF,
                                version: data.latestPublishVersion,
                                lang: fileLang.EN,
                                published: true,
                                hidden: type === POLICY_NAME.DPA,
                            }
                        );
                    }
                }
            }
            setDataSource(genarate.filter((m) => !m.hidden));
        }
    }, [data, privacyName, currentSelectName]);

    const colunms = [
        {
            title: 'File Name',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => (
                <div className="flex items-center space-x-2">
                    <i className="flex-shrink-0">
                        {record.type === fileTypes.PDF
                            ? iconType.pdf
                            : iconType.docx}
                    </i>
                    <span className="text-sm text-[#65707A] font-semibold">
                        {text}.{record.type}
                    </span>
                </div>
            ),
        },
        {
            title: 'Version',
            dataIndex: 'version',
            key: 'version',
            render: (text, record) => (
                <div className="flex items-center space-x-2">
                    <div className="text-[#65707A] font-semibold text-sm">
                        {text}
                    </div>
                    <div
                        className={classNames(
                            'rounded-full px-3 text-xs font-medium flex-shrink-0',
                            {
                                'text-[#1890FF]': !record.published,
                                'text-[#4ACE8F]': record.published,
                            }
                        )}
                        style={
                            record.published
                                ? {
                                      border: '1px solid #4ACE8F',
                                  }
                                : {
                                      border: '1px solid #1890FF',
                                  }
                        }
                    >
                        {record.published ? 'Published' : 'Latest Version'}
                    </div>
                </div>
            ),
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            align: 'center',
            render: (_, record) => {
                if (record.type === fileTypes.PDF) {
                    if (record.hasChanged)
                        if (record.published)
                            return (
                                <DownloadPdf
                                    record={record}
                                    data={data}
                                    privacyId={privacyId}
                                    htmlEn={htmlPublishEn}
                                    html={htmlPublish}
                                />
                            );
                        else
                            return (
                                <DownloadPdf
                                    record={record}
                                    data={data}
                                    privacyId={privacyId}
                                    htmlEn={htmlEn}
                                    html={html}
                                />
                            );
                    else
                        return (
                            <DownloadPdf
                                record={record}
                                data={data}
                                privacyId={privacyId}
                                htmlEn={htmlEn}
                                html={html}
                            />
                        );
                } else {
                    if (record.hasChanged) {
                        if (record.published)
                            return (
                                <Button
                                    disabled={isAuditor}
                                    onClick={() => {
                                        let blob = new Blob(
                                            [
                                                record.lang === 'TH'
                                                    ? htmlPublish
                                                    : htmlPublishEn,
                                            ],
                                            {
                                                type: 'text/html',
                                            }
                                        );
                                        let url = URL.createObjectURL(blob);
                                        window.open(url);
                                    }}
                                    className="bg-[#F3F6F9] border-none"
                                    icon={
                                        <DownloadOutlined className="text-purple" />
                                    }
                                ></Button>
                            );
                        else
                            return (
                                <Button
                                    disabled={isAuditor}
                                    onClick={() => {
                                        let blob = new Blob(
                                            [
                                                record.lang === 'TH'
                                                    ? html
                                                    : htmlEn,
                                            ],
                                            {
                                                type: 'text/html',
                                            }
                                        );
                                        let url = URL.createObjectURL(blob);
                                        window.open(url);
                                    }}
                                    className="bg-[#F3F6F9] border-none"
                                    icon={
                                        <DownloadOutlined className="text-purple" />
                                    }
                                ></Button>
                            );
                    } else
                        return (
                            <Button
                                disabled={isAuditor}
                                onClick={() => {
                                    let blob = new Blob(
                                        [record.lang === 'TH' ? html : htmlEn],
                                        {
                                            type: 'text/html',
                                        }
                                    );
                                    let url = URL.createObjectURL(blob);
                                    window.open(url);
                                }}
                                className="bg-[#F3F6F9] border-none"
                                icon={
                                    <DownloadOutlined className="text-purple" />
                                }
                            ></Button>
                        );
                }
            },
        },
    ];

    return (
        <div
            hidden={type === 'cookie'}
            className="bg-white rounded-md shadow-sm w-full p-4"
        >
            <div className="text-xl font-medium">Download file</div>
            <Table
                className="mt-4 inbox_table"
                dataSource={dataSource}
                columns={colunms}
                pagination={false}
            />
        </div>
    );
};

const iconType = {
    pdf: (
        <svg
            width="19"
            height="24"
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M3.64994 0H11.6739L18.4745 7.08846V20.8756C18.4745 22.6027 17.0772 24 15.3561 24H3.64994C1.92281 24 0.525513 22.6027 0.525513 20.8756V3.12443C0.525482 1.3973 1.92278 0 3.64994 0V0Z"
                fill="#E5252A"
            />
            <path
                opacity="0.302"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.668 0V7.03449H18.4746L11.668 0Z"
                fill="white"
            />
            <path
                d="M3.9978 17.9072V13.5234H5.86288C6.32465 13.5234 6.69048 13.6494 6.96633 13.9072C7.24219 14.1591 7.38013 14.501 7.38013 14.9267C7.38013 15.3525 7.24219 15.6944 6.96633 15.9462C6.69048 16.2041 6.32465 16.33 5.86288 16.33H5.11924V17.9072H3.9978ZM5.11924 15.3765H5.73694C5.90484 15.3765 6.03678 15.3405 6.12675 15.2566C6.2167 15.1786 6.2647 15.0707 6.2647 14.9268C6.2647 14.7829 6.21673 14.6749 6.12675 14.5969C6.03681 14.513 5.90488 14.477 5.73694 14.477H5.11924V15.3765ZM7.84188 17.9072V13.5234H9.3951C9.70095 13.5234 9.98881 13.5654 10.2587 13.6554C10.5285 13.7453 10.7744 13.8713 10.9903 14.0452C11.2062 14.2131 11.3801 14.441 11.506 14.7288C11.626 15.0167 11.692 15.3465 11.692 15.7183C11.692 16.0842 11.626 16.414 11.506 16.7018C11.3801 16.9897 11.2062 17.2176 10.9903 17.3855C10.7744 17.5594 10.5285 17.6853 10.2587 17.7753C9.98881 17.8652 9.70095 17.9072 9.3951 17.9072H7.84188ZM8.93933 16.9537H9.26316C9.43707 16.9537 9.599 16.9358 9.74892 16.8938C9.89284 16.8518 10.0308 16.7858 10.1627 16.6959C10.2887 16.6059 10.3906 16.48 10.4626 16.3121C10.5345 16.1442 10.5705 15.9462 10.5705 15.7183C10.5705 15.4845 10.5345 15.2866 10.4626 15.1187C10.3906 14.9508 10.2887 14.8248 10.1627 14.7348C10.0308 14.6449 9.89287 14.5789 9.74892 14.537C9.599 14.495 9.43707 14.477 9.26316 14.477H8.93933V16.9537ZM12.2557 17.9072V13.5234H15.3741V14.477H13.3771V15.1786H14.9723V16.1261H13.3771V17.9072H12.2557Z"
                fill="white"
            />
        </svg>
    ),
    docx: (
        <svg
            width="19"
            height="24"
            viewBox="0 0 19 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M3.64727 0H11.6775L18.475 7.09195V20.8779C18.475 22.6023 17.0773 24 15.3529 24H3.64727C1.92281 24 0.525146 22.6023 0.525146 20.8779V3.12212C0.525146 1.39769 1.92281 0 3.64727 0V0Z"
                fill="#0263D1"
            />
            <path
                opacity="0.302"
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11.6678 0V7.0337H18.4751L11.6678 0Z"
                fill="white"
            />
            <path
                d="M3.42407 17.1238V13.1508H4.83147C5.11293 13.1508 5.37502 13.1928 5.61768 13.2705C5.86033 13.3514 6.08033 13.4678 6.27771 13.6232C6.47505 13.7784 6.63037 13.9855 6.7436 14.2443C6.85683 14.5032 6.91509 14.8008 6.91509 15.1373C6.91509 15.4738 6.85683 15.7714 6.7436 16.0302C6.63037 16.2891 6.47505 16.4961 6.27771 16.6514C6.08036 16.8067 5.86033 16.9232 5.61768 17.0041C5.37502 17.0818 5.11296 17.1238 4.83147 17.1238H3.42407ZM4.41733 16.26H4.71175C4.87028 16.26 5.01911 16.2406 5.15175 16.205C5.28763 16.1662 5.41056 16.1047 5.52704 16.0238C5.64351 15.9429 5.73409 15.8264 5.7988 15.6744C5.86676 15.5255 5.89908 15.3443 5.89908 15.1373C5.89908 14.9302 5.86673 14.7491 5.7988 14.597C5.73409 14.4482 5.64351 14.3317 5.52704 14.2508C5.41056 14.1667 5.28763 14.1085 5.15175 14.0696C5.01911 14.034 4.87028 14.0146 4.71175 14.0146H4.41733V16.26ZM9.32541 17.1691C8.72688 17.1691 8.23187 16.975 7.84039 16.59C7.44891 16.205 7.25477 15.7197 7.25477 15.1373C7.25477 14.555 7.44891 14.0696 7.84039 13.6847C8.23187 13.2996 8.72688 13.1055 9.32541 13.1055C9.91424 13.1055 10.4028 13.2997 10.7943 13.6847C11.1825 14.0697 11.3766 14.555 11.3766 15.1373C11.3766 15.7197 11.1825 16.205 10.7943 16.59C10.4028 16.975 9.91424 17.1691 9.32541 17.1691ZM8.56186 15.9753C8.7592 16.1953 9.01156 16.3053 9.31892 16.3053C9.62629 16.3053 9.8754 16.1953 10.0728 15.9753C10.2701 15.752 10.3672 15.4738 10.3672 15.1373C10.3672 14.8008 10.2701 14.5226 10.0728 14.2993C9.87543 14.0793 9.62629 13.9693 9.31892 13.9693C9.01156 13.9693 8.7592 14.0793 8.56186 14.2993C8.36451 14.5226 8.2642 14.8008 8.2642 15.1373C8.2642 15.4738 8.36451 15.752 8.56186 15.9753ZM13.7385 17.1691C13.1593 17.1691 12.6772 16.9879 12.2955 16.6321C11.9105 16.2729 11.7196 15.7747 11.7196 15.1373C11.7196 14.5032 11.9137 14.0049 12.302 13.6458C12.6935 13.2867 13.1691 13.1055 13.7385 13.1055C14.2529 13.1055 14.6735 13.2316 15.0068 13.4872C15.3368 13.7396 15.5277 14.0761 15.5762 14.4967L14.5732 14.7005C14.5312 14.4805 14.4308 14.3026 14.2756 14.1699C14.1203 14.0372 13.9391 13.9693 13.732 13.9693C13.4473 13.9693 13.2111 14.0696 13.0202 14.2734C12.8293 14.4805 12.7322 14.7652 12.7322 15.1373C12.7322 15.5093 12.8293 15.794 13.017 15.9979C13.2078 16.2049 13.444 16.3053 13.732 16.3053C13.939 16.3053 14.117 16.247 14.2626 16.1306C14.4082 16.0141 14.4988 15.8588 14.5376 15.6647L15.5632 15.8976C15.4694 16.2988 15.2623 16.6094 14.9388 16.8326C14.6185 17.0559 14.2173 17.1691 13.7385 17.1691Z"
                fill="white"
            />
        </svg>
    ),
};

export default DownloadFiles;
